import React from "react";
import { ChartContext } from "./contextProvider";

function useChartContext() {
  const context = React.useContext(ChartContext);

  return context;
}

export default useChartContext;
